import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchTrackJump, fetchCatJumping, fetchTrackJumpPeriode } from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget } from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import CatJump from "./catjump";
import IconSettings from "@material-ui/icons/Settings";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import FormControl from "@material-ui/core/FormControl";
import _ from "lodash";
import { NavLink, withRouter } from "react-router-dom";
import Button from "components/CustomButtons/Button.jsx";
import { pushLoader } from "../../actions/main";
import moment from "moment";
import ReactExport from "assets/libs/react-export-excel";
import { TextField } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Jumping Vessel ${moment().format('LLL')}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  }
});

let delay = null

class Jump extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      selectedCategory: "",
      selectedCategoryPeriode: "1",
      catjump: [],
      loader: null,
      startDate: moment()
        .subtract(1, "hours")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      totalData: 100,
      searchCheck: null,
      keyword: null,
      sort: ['none', 'none', 'none', 'desc', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none' ],
      orderby: `"dateCreated"`,
      activeColumn: 3,
      displayStatus: [true, true, false, true, true, true, false, false, false, false, false, false, true]
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchCatJumping()
      .then((response) => {
        if (response != null) {
          const dat = response.data.results;
          this.setState({
            catjump: response.data.results,
            selectedCategory: dat[0].id,
          });
          // fetchTrackJump(dat[0].id, this.state.selectedCategoryPeriode)
          // .then(response => {
          //   if (response != null) {
          //     this.setState({ datatable: response.data.results });
          //   }
          // })
          // .catch(error => {
          //   console.log(error);
          // });
          this.handleSearch(10, 0)
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
      });
  }

  handleClose = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  renderOptcat = (e) => {
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  handlecat = (e) => {
    this.setState({ selectedCategory: e.target.value });
    fetchTrackJump(e.target.value, this.state.selectedCategoryPeriode)
      .then((response) => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    //
    // fetchTrackSpeed(e.target.value, this.state.selectedCategoryPeriode)
    // .then(response => {
    //   if (response != null) {
    //     this.setState({ datatable: response.data.results });
    //   }
    // })
    // .catch(error => {
    //   console.log(error);
    // });
  };

  handlecatperiode = (e) => {
    this.setState({ selectedCategoryPeriode: e.target.value });

    fetchTrackJump(this.state.selectedCategory, e.target.value)
      .then((response) => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    // fetchTrackJumping(this.state.selectedCategory, e.target.value)
    //   .then(response => {
    //     if (response != null) {
    //       this.setState({ datatable: response.data.results });
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  };

  handleStartDate = (e) => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = (e) => {
    this.setState({ endDate: e.target.value });
  };

  handleSearchClick = async() => {
    await this.setState({
      searchCheck: true,
      sort: [
        "none",
        "none",
        "none",
        "desc",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
      ],
      orderby: `"dateCreated"`,
      activeColumn: 3,
    });
    this.handleSearch(10, 0);
  };

  handleKeyword = async(e) => {
    await this.setState({ keyword: e })
    await this.handleSearch(10, 0)
  }

  handleSearch = (rows, page) => {
    this.setState({ loader: true, datatable: [] });
    fetchTrackJumpPeriode(
      this.state.startDate,
      this.state.endDate,
      rows,
      page*rows,
      this.state.catjump[0].id,
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : ''
    )
      .then((response) => {
        if (response != null) {
          this.setState({ datatable: response.data.results, totalData: response.data.total });
          this.setState({ loader: false });
        }
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "shipid",
        label: "Ship ID",
        options: {
          filter: false,
          display: this.state.displayStatus[0],
          sortDirection: this.state.sort[0]
        },
      },
      {
        name: "name",
        label: "Ship Name",
        options: {
          filter: false,
          display: this.state.displayStatus[1],
          sortDirection: this.state.sort[1]
        },
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: this.state.displayStatus[2],
          sortDirection: this.state.sort[2]
        },
      },
      {
        name: "dateCreated",
        label: "DateCreated",
        options: {
          filter: false,
          display: this.state.displayStatus[3],
          sortDirection: this.state.sort[3]
        },
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: this.state.displayStatus[4],
          sortDirection: this.state.sort[4]
        },
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: this.state.displayStatus[5],
          sortDirection: this.state.sort[5]
        },
      },
      {
        name: "near_shipid",
        label: "Near Shipid",
        options: {
          filter: false,
          display: this.state.displayStatus[6],
          sortDirection: this.state.sort[6]
        },
      },
      {
        name: "near_name",
        label: "Near Name",
        options: {
          filter: false,
          display: this.state.displayStatus[7],
          sortDirection: this.state.sort[7]
        },
      },
      {
        name: "near_shiptype",
        label: "Near Shiptype",
        options: {
          filter: false,
          display: this.state.displayStatus[8],
          sortDirection: this.state.sort[8]
        },
      },
      {
        name: "near_dateCreated",
        label: "Near DateCreated",
        options: {
          filter: false,
          display: this.state.displayStatus[9],
          sortDirection: this.state.sort[9]
        },
      },
      {
        name: "near_latitude",
        label: "Near Latitude",
        options: {
          filter: false,
          display: this.state.displayStatus[10],
          sortDirection: this.state.sort[10]
        },
      },
      {
        name: "near_longitude",
        label: "Near Longitude",
        options: {
          filter: false,
          display: this.state.displayStatus[11],
          sortDirection: this.state.sort[11]
        },
      },
      {
        name: "distance_meter",
        label: "Distance in Mile",
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let valbaru = value * 0.000621371;
            return valbaru;
          },
          display: this.state.displayStatus[12],
          sortDirection: this.state.sort[12]
        },
      },
      {
        name: "Action",
        options: {
          sort: false,
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() =>
                    this.props.pushPoiTarget([
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                    ])
                  }
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          },
        },
      },
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: "none",
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found",
        },
      },
      onTableChange: async(action, tableState) => {
        switch (action) {
          case "changePage":
            this.handleSearch(tableState.rowsPerPage, tableState.page)
            break
          case "changeRowsPerPage":
            this.handleSearch(tableState.rowsPerPage, tableState.page)
            break
          case "propsUpdate":
            if (this.state.searchCheck) {
              this.setState({searchCheck: false})
              tableState.page = 0
              tableState.rowsPerPage = 10
            }
            break
          case "sort":
            tableState.page = 0;
            const condition = tableState.announceText.split(" ");
            const listColumn = this.state.sort;
            listColumn.forEach((value, index) => {
              let ascdesc;
              if (index === tableState.activeColumn) {
                if (condition[6] === "ascending") {
                  ascdesc = "asc";
                } else {
                  ascdesc = "desc";
                }
                this.state.sort[tableState.activeColumn] = ascdesc;
              } else {
                this.state.sort[index] = "none";
              }
            });
            await this.setState({
              orderby:
                tableState.columns[tableState.activeColumn].name ===
                "dateCreated"
                  ? `"dateCreated"`
                  : tableState.columns[tableState.activeColumn].name,
              activeColumn: tableState.activeColumn,
            });
            this.handleSearch(tableState.rowsPerPage, tableState.page, this.state.activeColumn, this.state.orderby);
            break;
          case "search":
            if (delay !== null) {
              clearTimeout(delay)
            }
            delay = setTimeout(async() => {
              let searchKeyword = tableState.searchText ? tableState.searchText : ''
              await this.handleKeyword(searchKeyword)
              tableState.searchText = this.state.keyword
            }, 3000)
          case "columnViewChange": {
            tableState.columns.forEach((column, index) => {
              if (column.display !== this.state.displayStatus[index]) {
                this.state.displayStatus[index] = column.display
              }
            })
          }
          default:
            break;
        }
      },
      serverSide: true,
      count: this.state.totalData,
      searchText: this.state.keyword
    };

    return (
      <div>
        <Grid item xs={12}>
          <div className={classes.content}>
            <Grid item xs={12}>
              <Button
                color="success"
                round
                onClick={() => this.handleClose("openAdd", true)}
              >
                <IconSettings /> Manage Category
              </Button>
            </Grid>
            <br />
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <FormControl variant="outlined">
                    <Select
                      value={this.state.selectedCategory}
                      onChange={this.handlecat}
                    >
                      {this.state.catjump.map(this.renderOptcat)}
                    </Select>
                  </FormControl>{" "}
                  {/* <FormControl variant="outlined">
                    <Select
                      value={this.state.selectedCategoryPeriode}
                      onChange={this.handlecatperiode}
                    >
                      <MenuItem value="1"> 1 Hour </MenuItem>
                      <MenuItem value="4"> 4 Hours </MenuItem>
                      <MenuItem value="24"> 1 Day </MenuItem>
                      <MenuItem value="168"> 1 Week </MenuItem>
                      <MenuItem value="720"> 1 Month </MenuItem>
                    </Select>
                  </FormControl> */}
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="Start Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.startDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.startDate,
                      onChange: this.handleStartDate
                    }}
                  />
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="End Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.endDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.endDate,
                      onChange: this.handleEndDate
                    }}
                  />
                  <Button 
                    color="primary"
                    variant="contained"
                    disabled={this.state.loader}
                    style={{marginRight: 20}}
                    onClick={() => this.handleSearchClick()}
                  >
                    Search
                  </Button>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <br />
              <ExcelFile
                element={
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={this.state.loader}
                  >
                    Download as .xslx
                  </Button>
                }
                filename={`${fileName}`}
                fileExtension="xslx"
              >
                <ExcelSheet data={this.state.datatable} name="Sheet 1">
                  <ExcelColumn label="Ship ID" value="shipid" />
                  <ExcelColumn label="Ship Name" value="name" />
                  <ExcelColumn label="DateCreated" value="dateCreated" />
                  <ExcelColumn label="Latitude" value="latitude" />
                  <ExcelColumn label="Longitude" value="longitude" />
                  <ExcelColumn
                    label="Distance in Mile"
                    value={(col) => col.distance_meter * 0.000621371}
                  />
                </ExcelSheet>
              </ExcelFile>
              <br />
              <MUIDataTable
                data={this.state.datatable}
                columns={columns}
                options={options}
              />
              <Dialog
                maxWidth={"md"}
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Manage Category
                </DialogTitle>
                <DialogContent>
                  <CatJump />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="danger"
                    round
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </div>
        </Grid>
      </div>
    );
  }
}

Jump.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushPoiTarget: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget, pushLoader }
)(withStyles(styles)(Jump)));
